import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { AppRoutingModule } from './app-routing.module';
import { HomeComponent } from './pages/home/home.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InmuebleInterceptor } from './services/interceptors/inmueble.interceptor';
import { CarruselComponent } from './pages/carrusel/carrusel.component';
import { BannerComponent } from './pages/banner/banner.component';
import { DomChangeDirective } from './directives/dom-change.directive';
import { SearchComponent } from './pages/search/search.component';
import { DetalleInmuebleComponent } from './pages/detalle-inmueble/detalle-inmueble.component';

//Mapas
import { InmueblesComponent } from './pages/inmuebles/inmuebles.component';
import { AppConfig } from './AppConfig';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { RouterTransformDirective } from './directives/router-transform.directive';
import { EstaticoGenericoComponent } from './pages/estatico-generico/estatico-generico.component';
import { DatePipe } from '@angular/common';
import { DirectorioContactoComponent } from './pages/directorio-contacto/directorio-contacto.component';
import { SafePipePipe } from './pipes/safe-pipe.pipe';
import { PopUpComponent } from './pages/pop-up/pop-up.component';

import { RouterModule } from '@angular/router';
import { WhatsappComponent } from './pages/whatsapp/whatsapp.component';
import { ContactanosComponent } from './pages/contactanos/contactanos.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgSelectModule } from '@ng-select/ng-select';
import { ContactanosDetalleComponent } from './pages/contactanos-detalle/contactanos-detalle.component';
import { Lightbox, LightboxConfig, LightboxEvent, LightboxModule } from 'ngx-lightbox';
import { LightboxWindowRef } from 'ngx-lightbox/lightbox-event.service';

@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        HomeComponent,
        CarruselComponent,
        BannerComponent,
        DomChangeDirective,
        RouterTransformDirective,
        SearchComponent,
        InmueblesComponent,
        DetalleInmuebleComponent,
        SafeHtmlPipe,
        EstaticoGenericoComponent,
        DirectorioContactoComponent,
        SafePipePipe,
        PopUpComponent,
        WhatsappComponent,
        ContactanosComponent,
        ContactanosDetalleComponent,
        
    ],
    bootstrap: [AppComponent], imports: [RouterModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgSelectModule,
        ReactiveFormsModule,GoogleMapsModule], providers: [
        DatePipe,Lightbox, LightboxConfig, LightboxEvent, LightboxWindowRef, LightboxModule,
        { provide: HTTP_INTERCEPTORS, useClass: InmuebleInterceptor, multi: true },
        AppConfig,
        { provide: APP_INITIALIZER, useFactory: (config: AppConfig) => () => config.load(), deps: [AppConfig], multi: true },
        provideHttpClient(withInterceptorsFromDi())
        
    ] })
export class AppModule { }
